import { render, staticRenderFns } from "./AuthMainLayout.vue?vue&type=template&id=99342de6&"
import script from "./AuthMainLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthMainLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports